import { apiUrl } from './tool'
import axios from 'axios'

const useMock = false

export function getHealthEduAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "id": "1",
          "category_name": "植牙"
        },
        {
          "id": "2",
          "category_name": "矯正"
        }
      ]
    })
  }
  const url = apiUrl('message', 'health_education')
  return axios.get(url, {params})
}

export function getMessagePatientAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "count": params.satisfaction ? 499 : 501,
        "data": [
          {
            "patient_code": "1f72ilba",
            "phone": "0922099195",
            "name": "蔡有人",
            "sex": "1",
            "birthday": "",
            "file_name_photo": ""
          }
        ]
      }
    })
  }
  const url = apiUrl('message', 'patient')
  return axios.get(url, {params})
}

export function getMessageSettingAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "own_channel": false,
        "channel_id": "1622774606",
        "remind_treatment": "0",
        "remind_day": "1",
        "remind_1day": "0",
        "remind_2day": "1"
      }
    })
  }
  const url = apiUrl('message', 'auto_setting')
  return axios.get(url, {params})
}

export function updateMessageSettingAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('message', 'auto_setting')
  return axios.post(url, data)
}

export function getMessageGroupLogAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "create_time": "2021-10-31 14:15:12",
          "content": "?1/1(五) 元旦休診一天！\r\n\r\n冷冷冬意，為大家送上暖心祝福～\r\n預㊗️大家2021年～新年快樂?\r\n　\r\n開心跨年後，若有口腔問題，歡迎儘早預約檢查治療，準備迎接農曆年，好好享受美食與家人歡聚時刻～\r\n\r\n?新的一年，英倫牙醫繼續為你守護牙齒健康！\r\n　\r\n#休診公告\r\n#0101全天休診",
          "image_url": "https://dentco.s3.us-east-2.amazonaws.com/line/5fed6b9e12ccc.png"
        }
      ]
    })
  }
  const url = apiUrl('message', 'group_log')
  return axios.get(url, {params})
}

export function getMessageRemindLogAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "create_time": "2021-11-15 14:40:09",
          "content": "蔡有人您好，您與 王醫師醫師 的約診時間為本日 18:00 於 Dent&Co牙醫診所1，請確認是否依約前往。\n備註：1.請提早五分鐘帶牙刷和牙膏來刷牙。\r\n\r\n2.因應防疫政策，請病患於就診前完成下列評估表，以利診所預防作業。https://tinyurl.com/dsmjwnpu 。\r\n\r\n3.就診前請下載臺灣社交距離 APP：http://onelink.to/wdxwyb 。到診請開給櫃檯確認\r\n"
        }
      ]
    })
  }
  const url = apiUrl('message', 'remind_log')
  return axios.get(url, {params})
}

export function getMessageActivitiesAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: [
        {
          "id": 1,
          "title": "2021父親節活動",
          "image_url": "https://i.imgur.com/A7dIOHo.jpg",
          "intro_url": "https://pse.is/3lv5fh",
          "start_date": "0000-00-00 00:00:00",
          "end_date": "0000-00-00 00:00:00",
          "sort": 99,
          "created_at": "2021-11-23 06:29:38",
          "updated_at": "2021-11-23 06:29:38"
        }
      ]
    })
  }
  const url = apiUrl('message', 'activity_list')
  return axios.get(url, {params})
}

export function uploadPanoImgAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "pano_id": "619cb69dbf87f",
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('message', 'pano')
  return axios.post(url, data)
}

export function sendMessageAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('message')
  return axios.post(url, data)
}

export function getMessagePermissionAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "send_restriction": "0"
      }
    })
  }
  const url = apiUrl('message', 'send_setting')
  return axios.get(url, {params})
}

export function getMessageSettingsAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "survey_type": "1",  // 設定在 clinic，實名優先 or google優先(診所登入才有)
        "mmm_verify": "0",
        "mmm_remind_child": "0",
        "mmm_remind_aldult": "1",
        "setting_data": [
          {
            "remind_setting": "159",
            "clinic_name": "Dent&Co牙醫診所",
            "doctor_name": "ClearCorrect",
            "reserve_day0": "1",  // 當天
            "reserve_day1": "0",  // 一天前
            "reserve_day2": "1",  // 兩天前
            "reserve_day0_time": "08:00",  // 當天
            "reserve_day1_time": "11:00",  // 一天前
            "reserve_day2_time": "12:00",  // 兩天前
            "treatment": "0",  // 是否開啟看診前15分鐘自動衛教
            "care": "0",  // 是否開啟看診後術後關懷
            "survey": "1",  // 是否開啟看診後評價邀請
            "survey_send_timing": 60,  // 評價傳送時間：正數=看診後N分鐘, -1=當天22:00, -2=隔天10:00
            "half_year": "1" // 是否開啟半年定檢提醒(半年定檢排程需要判斷這個開關)
          },
          {
            "remind_setting_id": "321",
            "clinic_name": "Dent&Co牙醫診所",
            "doctor_name": "王醫師",
            "reserve_day0": "1",
            "reserve_day1": "0",
            "reserve_day2": "1",
            "reserve_day0_time": "08:00",
            "reserve_day1_time": "11:00",
            "reserve_day2_time": "12:00",
            "treatment": "0",
            "care": "0",
            "survey": "1",
            "survey_send_timing": 60,  // 評價傳送時間
            "half_year": "1"
          }
        ],
        "own_channel": true, //有沒有小OA
        "channel_id": "1655684989"
      }
    })
  }
  const url = apiUrl('message', 'line_setting')
  return axios.get(url, {params})
}

export function updateMessageSettingsAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('message', 'line_setting')
  return axios.post(url, data)
}

export function getLineMessageGroupLogsAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "paginate": {
          "page": "1",
          "limit": "1",
          "page_total": "2",
          "total": "2"
        },
        "data": [
          {
            "create_time": "2021-10-31 14:15",
            "content": "?1/1(五) 元旦休診一天！\r\n\r\n冷冷冬意，為大家送上暖心祝福～\r\n預㊗️大家2021年～新年快樂?\r\n　\r\n開心跨年後，若有口腔問題，歡迎儘早預約檢查治療，準備迎接農曆年，好好享受美食與家人歡聚時刻～\r\n\r\n?新的一年，英倫牙醫繼續為你守護牙齒健康！\r\n　\r\n#休診公告\r\n#0101全天休診",
            "image_url": "https://dentco.s3.us-east-2.amazonaws.com/line/5fed6b9e12ccc.png",
            "patient_name": "吳薏凡"
          }
        ]
      }
    })
  }
  const url = apiUrl('message', 'group_log')
  return axios.get(url, {params})
}

export function getLineMessageRemindLogsAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "paginate": {
          "page": "1",
          "limit": "1",
          "page_total": "9",
          "total": "9"
        },
        "data": [
          {
            "create_time": "2023-06-15 10:12",
            "content": "蔡友仁您好，提醒您與 王醫師醫師 的約診時間為 2023-06-17 10:00 於 Dent&Co牙醫診所。\n備註：\n若有以下症狀請配合改約\r\n*發燒/感冒/咳嗽/呼吸道症狀或他國入境，未達14天居家檢疫者無法進行牙科看診。\r\n\r\n若有＊看診陪同者＊，當日亦需攜帶健保卡",
            "patient_name": "蔡友仁"
          }
        ]
      }
    })
  }
  const url = apiUrl('message', 'remind_log')
  return axios.get(url, {params})
}

export function downloadLineMessageGroupDetailLogsAPI(log_no, params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('message', 'download', 'group_log', log_no)
  return axios.get(url, {params, responseType: 'blob'})
}

export function downloadLineMessageGroupLogsAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('message', 'download', 'group_log')
  return axios.get(url, {params})
}

export function downloadLineMessageRemindLogsAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('message', 'download', 'remind_log')
  return axios.get(url, {params})
}

export function getSmartCareLogsAPI(params) {
  const url = apiUrl('message', 'smart_care_log')
  return axios.get(url, {params})
}

export function downloadSmartCareLogsAPI(params) {
  const url = apiUrl('message', 'download', 'smart_care_log')
  return axios.get(url, {params})
}

export function sendLineHalfYearRemindAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('reserves', 'remind_half_year')
  return axios.post(url, data)
}

export function sendLineMessageAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('anywhere', 'push-line')
  return axios.post(url, data)
}

export function getMessageChannelInfoAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('anywhere', 'info')
  return axios.get(url, {params})
}

